import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule, UrlTree, UrlSegmentGroup, PRIMARY_OUTLET, UrlSegment } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { environment } from '../environments/environment';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [CommonModule, RouterModule],
})
export class AppComponent implements OnInit {
  title = 'hotel-self-inventory-ui';
  
  constructor(
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    const keyFromUrl = urlParams.get('Key');
    
    if (keyFromUrl) {
      const decodedKey = decodeURIComponent(keyFromUrl);
      this.autoTokenLogin(decodedKey);
      this.router.navigate([], {
        queryParams: { 'Key': null },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }
    
    this.checkForHashFragment();
    
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkForAutoLoginToken();
        this.checkForHashFragment();
      });
  }
  
  private checkForHashFragment() {
    const hash = window.location.hash;
    if (hash && hash.includes('Key=')) {
      try {
        // Extract key from hash fragment
        const keyParam = hash.substring(hash.indexOf('Key=') + 'Key='.length);
        const key = keyParam.includes('&') 
          ? keyParam.substring(0, keyParam.indexOf('&')) 
          : keyParam;
          
        if (key) {
          const decodedKey = decodeURIComponent(key);
          this.autoTokenLogin(decodedKey);
          
          // Remove hash from URL
          window.location.hash = '';
        }
      } catch (error) {
        console.error('Error processing hash fragment:', error);
      }
    }
  }
  
  checkForAutoLoginToken() {
    this.route.queryParams.subscribe(params => {
      const key = params['Key'];
      
      if (key) {
        const decodedKey = decodeURIComponent(key);
        this.autoTokenLogin(decodedKey);
        
        this.router.navigate([], {
          queryParams: { 'Key': null },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      }
    });
  }

  autoTokenLogin(token: string) {
    const autoTokenKey = {
      encryptedKey: token,
    };
    
    this.http
      .post(`${environment.apiUrl}/user/auto-login`, autoTokenKey)
      .subscribe({
        next: (res: any) => {
          if (res?.data) {
            localStorage.setItem('isLoggedIn', JSON.stringify(res));
            // localStorage.setItem('isLoggedIn', JSON.stringify(res));
            this.router.navigate(['/home/manageHotelContent/allContentList']);
          } else {
            this.router.navigate(['/auth/login']);
          }
        },
        error: (err) => {
          console.error('Auto login error:', err);
          this.router.navigate(['/auth/login']);
        },
      });
  }
}